/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import React, { PropsWithChildren, useEffect } from "react"
import { Backdrop, CircularProgress, Snackbar } from "@mui/material"
import { useMediaQuery } from "react-responsive"
import { SNACKBAR_TYPES } from "src/modules/const"
import { ShowProgress } from "src/states/showProgress"
import { ShowToast } from "src/states/showToast"
import { useRecoilState } from "recoil"
import "./index.scss"

const MainLayout: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const isTablet = useMediaQuery({ query: "(max-width: 1280px)" })

  const [showToast, setShowToast] = useRecoilState(ShowToast)
  const [showProgress, setShowProgress] = useRecoilState(ShowProgress)

  useEffect(() => {
    if (showToast.show) {
      setShowProgress(false)
      setTimeout(() => {
        setShowToast({ show: false, text: "", type: showToast.type })
      }, 5000)
    }
  }, [showToast])

  const snackBarColor = () => {
    switch (showToast.type) {
      case SNACKBAR_TYPES.ERROR:
        return "#D32F2F"
      case SNACKBAR_TYPES.WARNING:
        return "#F57C00"
      case SNACKBAR_TYPES.INFORMATION:
        return "#0288D1"
      case SNACKBAR_TYPES.SUCCESS:
        return "#E2F3FF"
    }
    return "black"
  }

  const snackBarFontColor = () => {
    if (showToast.type == SNACKBAR_TYPES.SUCCESS) {
      return "black"
    }
    return "white"
  }

  return (
    <>
      {children}
      <Snackbar
        open={showToast.show}
        anchorOrigin={{ vertical: "top", horizontal: isTablet ? "center" : "right" }}
        message={showToast.text}
        ContentProps={{
          sx: {
            bgcolor: snackBarColor(),
            color: snackBarFontColor(),
            fontSize: "15px",
            fontFamily: "Zen Kaku Gothic New !important",
            fontWeight: 400,
            justifyContent: "center",
          },
        }}
      />
      <Backdrop sx={{ color: "#fff", zIndex: 10000 }} open={showProgress}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  )
}

export default MainLayout
